<script>
import ChatDetailModal from './Detail.vue';
import axios from "@/lib/axios";
import Swal from "sweetalert2";

export default {
  components: {
    ChatDetailModal
  },

  data() {
    return {
      chats: {
        data: [],
        current_page: 1,
        per_page: 10,
        total: 0,
        from: 0,
        to: 0
      },
      kategories: [
        { id: 1, nama: 'Bug / Error', color: 'bg-danger' },
        { id: 2, nama: 'Fitur Baru', color: 'bg-primary' },
        { id: 3, nama: 'Peningkatan', color: 'bg-info' },
        { id: 4, nama: 'UI/UX', color: 'bg-warning' },
        { id: 5, nama: 'Lainnya', color: 'bg-secondary' }
      ],
      filters: {
        status: 'all',
        kategori: 'all'
      },
      showCreateModal: false,
      selectedChat: null,
      loading: false,
      newChat: {
        id_kategori_komplain: '',
        chat: ''
      },
      currentPage: 1,
      currentUser: null,
      userRoles: [],
    };
  },

  watch: {
    currentPage(newPage) {
      this.loadChats(newPage);
    }
  },

  mounted() {
    this.loadChats();
    this.checkUserAndRoles();
  },

  methods: {
    async checkUserAndRoles() {
      try {
        const roleResponse = await axios.get('/api/check-roles');
        this.userRoles = roleResponse.data.roles;

        const userResponse = await axios.get('/api/me');
        this.currentUser = userResponse.data;
      } catch (error) {
        console.log('Gagal memuat data: ', error);
      }
    },

    async loadChats(page = 1) {
      try {
        const params = {
          page,
          status: this.filters.status !== 'all' ? this.filters.status : null,
          kategori: this.filters.kategori !== 'all' ? this.filters.kategori : null,
          per_page: this.chats.per_page
        };

        const response = await axios.get('/api/chats', { params });
        this.chats = response.data.data;
        this.currentPage = this.chats.current_page;
      } catch (error) {
        this.$toast.error('Gagal memuat data kritik/saran');
      }
    },

    async createNewChat() {
      this.loading = true;
      try {
        await axios.post('/api/chats', this.newChat);
        
        this.showCreateModal = false;
        this.resetNewChat();
        this.loadChats();

        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Kritik/saran berhasil dikirim!",
        });
        
      } catch (error) {
        console.log('Gagal mengirim data: ', error);
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal mengirim kritik/saran!",
        });
      } finally {
        this.loading = false;
      }
    },

    resetNewChat() {
      this.newChat = {
        id_kategori_komplain: '',
        chat: ''
      };
    },

    openChatDetail(chat) {
      this.selectedChat = chat;
    },

    handleReplyAdded(updatedChat) {
      if (this.selectedChat && this.selectedChat.id === updatedChat.id) {
        this.selectedChat = updatedChat;
      }
      
      this.updateChatInList(updatedChat);
    },

    handleStatusUpdated(updatedChat) {
      if (this.selectedChat && this.selectedChat.id === updatedChat.id) {
        this.selectedChat = updatedChat;
      }
      
      this.updateChatInList(updatedChat);
    },

    updateChatInList(updatedChat) {
      const index = this.chats.data.findIndex(chat => chat.id === updatedChat.id);
      if (index !== -1) {
        this.chats.data.splice(index, 1, updatedChat);
      }
    },

    getKategoriName(kategoriId) {
      const kategori = this.kategories.find(k => k.id === kategoriId);
      return kategori ? kategori.nama : 'Unknown';
    },

    getKategoriBadgeClass(kategoriId) {
      const kategori = this.kategories.find(k => k.id === kategoriId);
      return kategori ? kategori.color : 'bg-secondary';
    },

    getFirstWords(text, wordCount = 10) {
      if (!text) return '';
      const words = text.split(' ');
      return words.slice(0, wordCount).join(' ') + (words.length > wordCount ? '...' : '');
    },

    getStatusBadgeClass(status) {
      const classes = {
        open: 'bg-warning',
        answered: 'bg-success',
        closed: 'bg-secondary'
      };
      return classes[status] || 'bg-secondary';
    },

    getStatusText(status) {
      const texts = {
        open: 'Open',
        answered: 'Answered',
        closed: 'Closed'
      };
      return texts[status] || status;
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString('id-ID');
    }
  }
};
</script>

<template>
  <BContainer fluid>
    <BRow>
      <BCard>
        <BCardHeader>
          <BCardTitle class="mb-0">Kritik & Saran</BCardTitle>
        </BCardHeader>
        <BCardBody>
          <!-- Filter Section -->
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-2">
              <div>
                <label class="form-label">Status</label>
                <select v-model="filters.status" class="form-select" @change="loadChats">
                  <option value="all">Semua Status</option>
                  <option value="open">Open</option>
                  <option value="answered">Answered</option>
                  <option value="closed">Closed</option>
                </select>
              </div>
              <div>
                <label class="form-label">Kategori</label>
                <select v-model="filters.kategori" class="form-select" @change="loadChats">
                  <option value="all">Semua Kategori</option>
                  <option v-for="kategori in kategories" :key="kategori.id" :value="kategori.id">
                    {{ kategori.nama }}
                  </option>
                </select>
              </div>
            </div>
            <div class="d-flex align-items-end">
              <button @click="showCreateModal = true" class="btn btn-primary">
                <i class="ri-add-line align-middle me-1"></i> Buat Kritik/Saran Baru
              </button>
            </div>
          </div>

          <!-- Chat List -->
          <div class="table-responsive mt-3">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Judul</th>
                  <th>Pengirim</th>
                  <th>Kategori</th>
                  <th>Status</th>
                  <th>Tanggal</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="chat in chats.data" :key="chat.id">
                  <td>
                    <strong>{{ getFirstWords(chat.details[0]?.chat) }}</strong>
                    <br>
                    <small class="text-muted">
                      {{ chat.details.length }} balasan
                    </small>
                  </td>
                  <td>{{ chat.nama_pengirim }}</td>
                  <td>
                    <span :class="getKategoriBadgeClass(chat.id_kategori_komplain)" class="badge">
                      {{ getKategoriName(chat.id_kategori_komplain) }}
                    </span>
                  </td>
                  <td>
                    <span :class="getStatusBadgeClass(chat.status)" class="badge">
                      {{ getStatusText(chat.status) }}
                    </span>
                  </td>
                  <td>{{ formatDate(chat.created_at) }}</td>
                  <td>
                    <button @click="openChatDetail(chat)" class="btn btn-sm btn-light">
                      <i class="ri-eye-line"></i> Lihat
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Empty State -->
            <div v-if="chats.data && chats.data.length === 0" class="text-center py-4">
              <div class="text-muted">
                <i class="ri-chat-off-line display-4"></i>
                <p class="mt-2">Belum ada kritik/saran</p>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="row mt-4" v-if="chats.data && chats.data.length > 0">
            <div class="col-lg-12">
              <div class="d-flex justify-content-between align-items-center flex-wrap">
                <div class="text-muted">
                  Menampilkan {{ chats.from }} sampai {{ chats.to }} dari {{ chats.total }} data
                </div>
                <BPagination
                  v-model="currentPage"
                  :total-rows="chats.total"
                  :per-page="chats.per_page"
                  pills
                  prev-text="←"
                  next-text="→"
                  hide-goto-end-buttons="true"
                  class="pagination-separated"
                />
              </div>
            </div>
          </div>
        </BCardBody>
      </BCard>
    </BRow>
  </BContainer>

  <!-- Modal Buat Kritik/Saran -->
  <div v-if="showCreateModal" class="modal fade show" style="display: block">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Buat Kritik/Saran Baru</h5>
          <button type="button" class="btn-close" @click="showCreateModal = false"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="createNewChat">
            <div class="mb-3">
              <label class="form-label">Kategori</label>
              <select v-model="newChat.id_kategori_komplain" class="form-select" required>
                <option value="">Pilih Kategori</option>
                <option v-for="kategori in kategories" :key="kategori.id" :value="kategori.id">
                  {{ kategori.nama }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Kritik/Saran</label>
              <textarea v-model="newChat.chat" class="form-control" rows="5" 
                        placeholder="Tuliskan kritik atau saran Anda..." required></textarea>
            </div>
            <div class="text-end">
              <button type="button" class="btn btn-light me-2" @click="showCreateModal = false">
                Batal
              </button>
              <button type="submit" class="btn btn-primary" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                Kirim
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showCreateModal" class="modal-backdrop fade show"></div>

  <!-- Modal Detail Chat -->
  <ChatDetailModal 
    v-if="selectedChat"
    :chat="selectedChat"
    :kategories="kategories"
    :current-user="currentUser"
    :user-roles="userRoles"
    @close="selectedChat = null"
    @reply-added="handleReplyAdded"
    @status-updated="handleStatusUpdated"
  />
</template>